import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl, umsUrl } from '../../../../../Containers/Config/index.js';
import { Constant } from '../../../../../Containers/Helpers/constant.js';
import apiCall from '../../../apiCall';
import { GET_TRENDING_USER, GET_TRENDING_USER_ERROR, GET_TRENDING_USER_SUCCESS } from './../../../actionType.js';

function* getTrendingUser({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/v1/user-trend/${payload?.type}`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_TRENDING_USER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_TRENDING_USER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_TRENDING_USER_ERROR, payload: error });
  }
}

export function* watchGetTrendingUser() {
  yield takeEvery(GET_TRENDING_USER, getTrendingUser);
}

function* getTrendingUserSaga() {
  yield all([fork(watchGetTrendingUser)]);
}

export default getTrendingUserSaga;
